import React, { useEffect, useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { verifyEmail } from '../services/api';
import Button from '../components/Button';
import { t } from '../i18n';
import './AuthPages.css';

const VerifyEmailPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [alreadyVerified, setAlreadyVerified] = useState(false);

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (!token) {
      setError(t('verify.error.noToken'));
      setLoading(false);
      return;
    }

    const verify = async () => {
      try {
        const response = await verifyEmail(token);
        if (response.data.alreadyVerified) {
          setAlreadyVerified(true);
        } else {
          setSuccess(true);
          // Redirect to login after 3 seconds
          setTimeout(() => {
            navigate('/login');
          }, 3000);
        }
      } catch (err: any) {
        setError(t('verify.error.generic'));
      } finally {
        setLoading(false);
      }
    };

    verify();
  }, [searchParams, navigate]);

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          <img src="/logo.webp" alt="X-periences" className="auth-logo" />
          <h1 className="auth-title">{t('verify.title')}</h1>
        </div>

        <div className="auth-form">
          {loading && (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <p>{t('verify.loading')}</p>
            </div>
          )}

          {error && (
            <div className="auth-error">
              {error}
            </div>
          )}

          {success && (
            <div className="form-success">
              <p style={{ marginBottom: '10px' }}>
                ✓ {t('verify.successLine1')}
              </p>
              <p style={{ fontSize: '14px', color: 'var(--text-muted)' }}>
                {t('verify.successLine2')}
              </p>
              <p style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '15px' }}>
                {t('verify.redirecting')}
              </p>
            </div>
          )}

          {alreadyVerified && (
            <div className="form-success">
              <p style={{ marginBottom: '10px' }}>
                {t('verify.alreadyLine1')}
              </p>
              <p style={{ fontSize: '14px', color: 'var(--text-muted)' }}>
                {t('verify.alreadyLine2')}
              </p>
            </div>
          )}

          {(success || alreadyVerified || error) && (
            <div style={{ marginTop: '20px' }}>
              <Link to="/login">
                <Button fullWidth>{t('verify.goLogin')}</Button>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;
